import axios from "axios";
import { getViewTenant } from "@/lib/viewTenant";
import { getDriverToken, onDriverRoute } from "@/lib/driverAuth";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Driver pages use the driver's own sign-in token; everything else uses Clerk.
export async function resolveToken(getToken) {
  if (onDriverRoute()) return getDriverToken();
  try {
    return await getToken();
  } catch {
    return null;
  }
}

export function makeApi(getToken) {
  const instance = axios.create({ baseURL: API });
  instance.interceptors.request.use(async (config) => {
    const token = await resolveToken(getToken);
    if (token) config.headers.Authorization = `Bearer ${token}`;
    const view = getViewTenant();
    if (view) config.headers["X-View-Tenant"] = view.id;
    return config;
  });
  return instance;
}

export async function authedUrl(path, getToken) {
  const token = await resolveToken(getToken);
  const view = getViewTenant();
  return `${API}${path}${path.includes("?") ? "&" : "?"}auth=${encodeURIComponent(token || "")}${view ? `&view_tenant=${view.id}` : ""}`;
}
